<template>
  <v-app>
    <v-toolbar app>
    <v-img
      :src="require('./assets/logo.svg')"
      class="my-3"
      contain
      max-height=50
      position='right'
      ></v-img>
      <v-toolbar-title class="headline text-uppercase">
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-content>
      <router-view></router-view>
    </v-content>

  </v-app>
</template>

<script>


export default {
  name: 'QabasEnergy',
  components: {

  },
  data () {
    return {
      //
    }
  }
}
</script>


<style>


</style>
